import { render, staticRenderFns } from "./VlIndexPaginationAmountFilter.vue?vue&type=template&id=962a82a2&scoped=true&"
import script from "./VlIndexPaginationAmountFilter.vue?vue&type=script&lang=js&"
export * from "./VlIndexPaginationAmountFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962a82a2",
  null
  
)

export default component.exports